/**
=========================================================
* ooGoal - v5.0.0
=========================================================

* Product Page: https://oogoal.com
* Copyright 2022 Onza Technologies

=========================================================

* The above copyright must be included
*/

const colors = {
  light: {
    main: "#E9E9E9",
    focus: "#E9E9E9",
  },

  dark: {
    main: "#1B1B1B",
    focus: "#1B1B1B",
  },

  background: {
    default: "#1B1B1B",
    sidenav: "#2E2E2E",
    navbar: "#2E2E2E",
    button: "#2E2E2E",
    card: "#2E2E2E",
    paper: "transparent",
  },

  text: {
    main: "#F0F2F5",
    focus: "#F0F2F5",
  },

  info: {
    main: "#F0F2F5",
    focus: "#F0F2F5",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#E9E9E9",
    focus: "#E6E6E6",
    card: "#FAF8FF",
  },

  black: {
    main: "#1B1B1B",
    focus: "#000000",
    card: "#111111",
  },

  green: {
    main: "#33FF66",
    state: "#0FDB49",
  },

  warning: {
    main: "#FB8C00",
    focus: "#FC9D26",
  },

  red: {
    main: "#F44335",
    state: "#F65F53",
  },

  grey: {
    100: "#F8F9FA",
    200: "#F0F2F5",
    300: "#DEE2E6",
    400: "#CED4DA",
    500: "#ADB5BD",
    600: "#6C757D",
    700: "#495057",
    800: "#343A40",
    900: "#212529",
  },
  /* ex primary*/
  grey250: {
    main: "#E2E5E9",
    focus: "#C5CBD3",
  },
  /* ex secondary*/
  grey650: {
    main: "#747b8A",
    focus: "#495361",
  },

  gradients: {
    /* ex primary*/
    grey250: {
      main: "#E2E5E9",
      state: "#C5CBD3",
    },
    /* ex secondary*/
    grey650: {
      main: "#747b8A",
      state: "#495361",
    },

    info: {
      main: "#49A3f1",
      state: "#1A73E8",
    },

    green: {
      main: "#33FF66",
      state: "#0FDB49",
    },

    warning: {
      main: "#FFA726",
      state: "#FB8C00",
    },

    red: {
      main: "#EF5350",
      state: "#E53935",
    },

    light: {
      main: "#EBEFF4",
      state: "#CED4DA",
    },

    dark: {
      main: "#323A54",
      state: "#1A2035",
    },
  },

  indicators: {
    verygood: {
      main: "#33FF33",
      state: "#00FF00",
    },

    good: {
      main: "#4DDBFF",
      state: "#00CCFF",
    },

    normal: {
      main: "#FFFFFF",
      state: "#CCCCCC",
    },

    bad: {
      main: "#FF8533",
      state: "#FF6600",
    },

    verybad: {
      main: "#FF4D4D",
      state: "#FF0000",
    },

    basewhite: {
      main: "#FFFFFF",
      state: "#CCCCCC",
    },

    basedark: {
      main: "#344767",
      state: "#2C3C58",
    },

    index: {
      main: "#0000FF",
      state: "#0000CC",
    },
  },

  badgeColors: {
    /* ex primary*/
    grey250: {
      main: "#E2E5E9",
      state: "#C5CBD3",
    },
    /* ex secondary*/
    grey650: {
      main: "#747b8A",
      state: "#495361",
    },

    info: {
      background: "#AECEf7",
      text: "#095BC6",
    },

    green: {
      background: "#BCE2BE",
      text: "#339537",
    },

    warning: {
      background: "#FFD59F",
      text: "#C87000",
    },

    red: {
      background: "#FCD3D0",
      text: "#F61200",
    },

    light: {
      background: "#FFFFFF",
      text: "#C7D3DE",
    },

    dark: {
      background: "#8097BF",
      text: "#1E2E4A",
    },
  },

  coloredShadows: {
    /* ex primary */
    grey250: "#E2E5E9",
    /* ex secondary */
    grey650: "#747b8A",
    info: "#00BBD4",
    green: "#0FDB49",
    warning: "#FF9900",
    red: "#F44336",
    light: "#ADB5BD",
    dark: "#404040",
  },

  inputBorderColor: "#D2D6DA",

  tabs: {
    indicator: { boxShadow: "#DDD" },
  },
};

export default colors;
